<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ 'components.editClassifierGroup.title' | translate }}
    </h4>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    @if (isLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isLoading"></app-spinner>
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="mb-3">
          <label class="form-label lna" for="name">
            {{ 'components.editClassifierGroup.name' | translate }}
          </label>
          <input
            class="form-control lna"
            id="name"
            [ngClass]="{
              invalid: this.shouldRenderError('name') && name?.errors
            }"
            formControlName="name"
            type="text"
            name="name" />
          @if (this.shouldRenderError('name') && name?.errors) {
            @if (name?.errors?.['required']) {
              <small class="error-message">
                {{ 'components.form.errorRequired' | translate }}
              </small>
            } @else if (name?.errors?.['minlength']) {
              <small class="error-message">
                {{ 'components.form.minLength' | translate: { name: name?.errors?.['minlength']['requiredLength'] } }}
              </small>
            } @else if (name?.errors?.['maxlength']) {
              <small class="error-message">
                {{
                  'components.form.maxLength'
                    | translate
                      : {
                          maxLength: name?.errors?.['maxlength']['requiredLength']
                        }
                }}
              </small>
            }
          }
        </div>
      </form>
    }
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="isLoading" (click)="handleSave()" type="button">
      {{ 'components.editClassifierGroup.save' | translate }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.editClassifierGroup.cancel' | translate }}
    </button>
  </div>
</ng-template>

<button class="secondary" (click)="open(content)">
  <img src="assets/images/edit-icon.svg" alt="edit" />
  {{ 'components.editClassifierGroup.edit' | translate }}
</button>
